module.exports = __webpack_public_path__ + "img/Previeweyezen-start_bd.7022929c.png";